export default "__VITE_PUBLIC_ASSET__de10a052__"